'use client'

import {FormProvider, useForm} from "react-hook-form";
import {FormInput} from "@/app/components/inputs/FormInput";
import {FormattedMessage} from "react-intl";
import styles from "@/app/styles/page/forgot-password/forgot-password-page.module.scss";
import {resetPasswordEmail} from "@/app/services/CreateAccountService";
import {useState} from "react";

const ForgotPasswordForm = () => {
    const methods = useForm({
        defaultValues: {
            user_email: '',
        }
    })
    const [notificationMessage, setNotificationMessage] = useState(null)
    const onSubmit = async (data) => {
        setNotificationMessage(null)
        const response = await resetPasswordEmail({data})
        setNotificationMessage(response.message)
    }
    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} className={`${styles.form} formStyle`}>
                <FormattedMessage id={'pages.forgotPassword.form.email'}>
                        {(message) =>
                             <FormInput
                                name={'user_email'}
                                styleLabel={''}
                                label={''}
                                type={'email'}
                                styleInput={styles.emailInput}
                                placeholder={message}
                                registerOptions={{
                                    required: true,
                                }}
                                error={methods.formState.errors?.user_email}
                            />
                        }
                    </FormattedMessage>
                 <FormattedMessage id={'pages.forgotPassword.form.button'}>
                     {(message) =>
                         <button type="submit" className={`${styles.submitBtn} btnGlobal`} disabled={methods.formState.isSubmitting}>{message}</button>
                     }
                 </FormattedMessage>
                {notificationMessage && <div className={styles.notificationMessage}>
                    <p>{notificationMessage}</p>
                </div>}
            </form>
        </FormProvider>
    )
}

export default ForgotPasswordForm;